import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7 } from "styled-components";
import React from "react";
import { takeFirst } from "~/features/app/utils";
import { getThemeStyle, type Mode, type Theme } from "~/features/ui/get-theme-style";
import { Grid } from "~/features/ui/grid";
import { Headline } from "~/features/ui/headline";
import { Wrap } from "~/features/ui/wrap";
type SectionDataAttrs = Record<`data-${string}`, string | undefined>;
export type TextMediaBlock1_3_BViewProps = {
  anchor?: Array<{
    id?: string | null;
    name?: string | null;
  }> | {
    id?: string | null;
    name?: string | null;
  } | null;
  hasTopDivider?: boolean | null;
  headline?: string | null;
  media?: React.ReactNode;
  mediaPosition?: string | null;
  mode?: string | null;
  sectionProps?: React.ComponentPropsWithoutRef<"section"> & SectionDataAttrs;
  theme?: string | null;
};
export function TextMediaBlock1_3_BView({
  anchor,
  hasTopDivider = true,
  headline,
  media,
  mediaPosition = "right",
  mode = "light",
  sectionProps,
  theme = "white"
}: TextMediaBlock1_3_BViewProps) {
  const themeStyle = getThemeStyle({
    mode: mode as Mode,
    theme: theme as Theme
  });
  const surface = theme === "grey" ? themeStyle.background : {
    "backgroundColor": "var(--bg-primary)"
  };
  const textCol = <_StyledDiv key="text-col" $_css={[{
    "position": "relative",
    "zIndex": "10",
    "gridColumn": "1 / -1",
    "display": "flex",
    "height": "100%",
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "rowGap": "1.6rem",
    "padding": "4rem",
    "@media (min-width: 1024px)": {
      "gridColumn": "span 4 / span 4",
      "padding": "8rem"
    }
  }, {
    "alignItems": "flex-start",
    "@media (min-width: 1024px)": {
      "minWidth": "50ch"
    }
  }, surface]}>
      {headline && <_StyledHeadline type="h2" text={headline} />}
    </_StyledDiv>;
  const mediaCol = <_StyledDiv2 key="media-col" $_css2={[{
    "gridColumn": "1 / -1",
    "padding": "var(--spacing-md)",
    "@media (min-width: 1024px)": {
      "gridColumn": "span 8 / span 8",
      "padding": "var(--spacing-xl)"
    }
  }, themeStyle.border, surface]}>
      <_StyledDiv3>{media}</_StyledDiv3>
    </_StyledDiv2>;
  const columns = mediaPosition === "right" ? [textCol, mediaCol] : [mediaCol, textCol];
  return <_StyledSection {...sectionProps} data-theme={mode as Mode} id={takeFirst(anchor)?.id || undefined} data-anchor-name={takeFirst(anchor)?.name || undefined} $_css3={[{
    "position": "relative",
    "color": "var(--text-primary)"
  }, surface, hasTopDivider && {
    "borderTopWidth": "1px",
    "borderColor": "var(--stroke-primary)"
  }]}>
      <_StyledWrap>
        <_StyledGrid $_css4={[{
        "@media (min-width: 1024px)": {
          "minHeight": "calc(570px + 80px * 2)"
        }
      }]}>{columns}</_StyledGrid>
      </_StyledWrap>
    </_StyledSection>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-sf-1ypgyzv-0"
})`${p => p.$_css}`;
var _StyledHeadline = _styled2(Headline).withConfig({
  componentId: "sc-sf-1ypgyzv-1"
})({
  "fontSize": "2.4rem",
  "lineHeight": "1.2",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "3.8rem",
    "lineHeight": "1.3",
    "letterSpacing": "0.038rem",
    "fontWeight": "400"
  }
});
var _StyledDiv2 = _styled3("div").withConfig({
  componentId: "sc-sf-1ypgyzv-2"
})`${p => p.$_css2}`;
var _StyledDiv3 = _styled4("div").withConfig({
  componentId: "sc-sf-1ypgyzv-3"
})({
  "position": "relative",
  "height": "100%",
  "width": "100%"
});
var _StyledSection = _styled5("section").withConfig({
  componentId: "sc-sf-1ypgyzv-4"
})`${p => p.$_css3}`;
var _StyledWrap = _styled6(Wrap).withConfig({
  componentId: "sc-sf-1ypgyzv-5"
})({
  "borderWidth": "0px"
});
var _StyledGrid = /*#__PURE__*/_styled7(Grid).withConfig({
  displayName: "text-media1_3_B___StyledGrid",
  componentId: "sc-dv6bz2-0"
})(["", ""], p => p.$_css4);